import { render, staticRenderFns } from "./TabEquipements.vue?vue&type=template&id=31d28844&"
import script from "./TabEquipements.vue?vue&type=script&lang=js&"
export * from "./TabEquipements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports